/**
 * useHostCardBack - Einzige Quelle für Card-Back CSS-Variablen
 *
 * Im Spiel: Zeigt die Kartenrückseite des aktuellen Card-Back-Setters
 * (Partie 1: Host, danach: der Arsch der letzten Partie).
 * Außerhalb des Spiels: Zeigt die eigene Profil-Einstellung.
 */

import { useEffect } from 'react';
import { useGameState } from '../state/GameContext';
import { useProfile } from '../contexts/ProfileContext';

const NON_GAME_PHASES = ['intro', 'gameModeSelect', 'lobby', 'profileSetup', 'startScreen', 'stammtischSetup', 'stammtisch'];

function applyCardBackCSS(color, image) {
  document.documentElement.setAttribute('data-card-scheme', color || 'classic');
  if (image) {
    document.documentElement.style.setProperty('--card-back-custom-image', `url(${image})`);
    document.documentElement.setAttribute('data-card-image', 'custom');
  } else {
    document.documentElement.style.removeProperty('--card-back-custom-image');
    document.documentElement.removeAttribute('data-card-image');
  }
}

export function useHostCardBack() {
  const { hostCardBackColor, hostCardBackImage, phase } = useGameState();
  const { cardBackColor, cardBackImage } = useProfile();

  useEffect(() => {
    const isInGame = phase && !NON_GAME_PHASES.includes(phase);

    if (isInGame) {
      // Im Spiel: Card-Back-Setter (Host/Arsch) bestimmt das Design für alle
      applyCardBackCSS(hostCardBackColor, hostCardBackImage);
    } else {
      // Außerhalb: Eigenes Profil-Design anwenden
      applyCardBackCSS(cardBackColor, cardBackImage);
    }
  }, [hostCardBackColor, hostCardBackImage, phase, cardBackColor, cardBackImage]);
}
